import { ITimezone } from '../interfaces/timezone';
import { axiosAdmin } from './axios';
import { TIMEZONES_FETCH_PATH } from '../core/paths';

export namespace TimezoneService {
  export function getList(): Promise<ITimezone[]> {
    return axiosAdmin.get<ITimezone[]>(TIMEZONES_FETCH_PATH).then(({ data }) => data);
  }
}